import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import InvitationPassword from "../../InvitationPassword";

const PassCodeModal = ({
	title,
	description,
	open,
	onClose,
	onSave,
	loading
}: {
	title: string;
	open: boolean;
	onClose: () => void;
	onSave: (passCode: string[]) => void;
	loading: boolean;
	description?: string;
}) => {
	const [passCode, setPassCode] = useState<string[]>(new Array(6).fill(""));
	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			maxWidth={"xs"}
		>
			<DialogTitle id="alert-dialog-title">{title}</DialogTitle>
			<DialogContent>
				{description && <Typography style={{ fontSize: "14px" }}>{description}</Typography>}
				<InvitationPassword passCode={passCode} setPassCode={setPassCode} />
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Cancel</Button>
				<Button
					onClick={() => {
						onSave(passCode);
					}}
					autoFocus
					loading={loading}
					disabled={loading}
				>
					Submit
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PassCodeModal;
